<app-customer-entra-card></app-customer-entra-card>

<div class="row">
  <div class="col-sm-12 col-md-12 col-xl-12">
    <app-paginator
      [length]="app.users.userIds.length"
      [index]="app.paginator.focus"
      (focus)="app.paginator.focus = $event"
    ></app-paginator>
    <div>
      <div
        class="tableFixHead"
        [ngClass]="{ tableHeight: app.filterTable.isDropdownOpen }"
        >
        <table class="table spacing-table userTable">
          <thead>
            <tr class="pointer">
              <th class="p-2">No.</th>
              @for (column of columnList; track column) {
                <th class="p-2">
                  @if (column === 'active') {
                    <span>
                      {{ app.field.getLabel("user." + column) }}</span
                      >
                    }
                    @if (column !== 'active') {
                      <span
                  (click)="
                    app.table.toggleSortDirection('user.' + column);
                    app.table.sort(app.users.users)
                  "
                        >
                        {{ app.field.getLabel("user." + column) }}</span
                        >
                        }&nbsp;
                        @if ('user.' + column === app.table.sortField) {
                          <span>
                            @if (app.table.sortDirection === 1) {
                              <i
                                class="fa fa-chevron-up"
                              ></i>
                            }
                            @if (app.table.sortDirection === -1) {
                              <i
                                class="fa fa-chevron-down"
                              ></i>
                            }
                          </span>
                        }
                        @if (app.filterTable.getFilterTableColumns(column)) {
                          <div>
                            <app-filter-table
                              [column]="column"
                              [columns]="columnList"
                              [docType]="'user'"
                              [cleanDocs]="app.users.cleanUsers"
                              [selectedFilters]="selectedFilters"
                    (resultedDocs)="
                      app.filterTable.getFilterResults($event, 'users')
                    "
                              >
                            </app-filter-table>
                          </div>
                        }
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (
                    user of app.paginator.getPage(app.users.users); track
                    user; let i = $index) {
                    <tr
                      [ngClass]="{ selectedRow: isSelected(user.name) }"
                      (click)="checkPermission(user.name, user.id);"
                      class="pointer"
                      >
                      <td class="px-2 py-1">{{ i + 1 }} </td>
                      @for (column of columnList; track column) {
                        <td class="px-2 py-1" >
                          @if (
                            column !== 'roles' &&
                            column !== 'active' &&
                            column !== 'passwordExpireDate'
                            ) {
                            <span
                              [ngClass]="{ selectedRow: isSelected(user.name) }"
                              >
                              {{
                              app.field.getFieldValueAsText(
                              "user." + column,
                              user[column]
                              )
                              }}
                            </span>
                          }
                          @if (column === 'roles') {
                            <span  [ngClass]="{ selectedRow: isSelected(user.name) }">
                              @for (role of user[column]; track role) {
                                <span>
                                  {{
                                  app.field.getOptionText(
                                  "user." + column,
                                  app.users.getCleanUserRole(role)
                                  )
                                  }}
                                </span>
                              }
                            </span>
                          }
                          @if (column === 'active') {
                            <span>
                              @if (!user[column]) {
                                <i class="fas fa-circle offline"></i>
                              }
                              @if (user[column]) {
                                <i class="fas fa-circle online"></i>
                              }
                            </span>
                          }
                          @if (column === 'passwordExpireDate' && user[column] > 0) {
                            <span
                              >
                              {{ user[column] | date : "yyyy-MM-dd" : "UTC" }}
                            </span>
                          }
                        </td>
                      }
                    </tr>
                  }
                  @if (app.users.userIds.length === 0) {
                    <tr
                      colspan="99"
                      class="text-center"
                      >
                      <td>
                        {{ app.text.app.noResults }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <app-paginator
            [length]="app.users.userIds.length"
            [index]="app.paginator.focus"
            (focus)="app.paginator.focus = $event"
          ></app-paginator>
        </div>
      </div>
